module.exports = __webpack_public_path__ + "static/img/LogQuery_active.5e8a7cd0.png";